import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ChangePassword from '../pages/ChangePassword'; // ✅ NEW

function Navbar({ onLogout, userInfo }) {
  const location = useLocation();
  const [menuOpen, setMenuOpen]           = useState(false);
  const [dropOpen, setDropOpen]           = useState(false);
  const [showChangePwd, setShowChangePwd] = useState(false); // ✅ NEW

  const isPremiumUser = userInfo?.account_type === 'premium' ||
                        userInfo?.account_type === 'business';

  const links = [
    { to: '/',          label: '📊 டாஷ்போர்டு' },
    { to: '/items',     label: '📦 பொருட்கள்' },
    { to: '/billing',   label: '🧾 பில்லிங்' },
    { to: '/customers', label: '👥 வாடிக்கையாளர்கள்' },
    { to: '/suppliers', label: '🏭 சப்ளையர்கள்' },
    { to: '/reports',   label: '📈 அறிக்கைகள்' },
    // ✅ Premium only — Staff Management
    ...(isPremiumUser ? [{ to: '/staff', label: '👥 ஊழியர்கள்' }] : []),
  ];

  const handleLogout = () => { setMenuOpen(false); setDropOpen(false); onLogout(); };

  const isActive = (path) =>
    path === '/'
      ? location.pathname === '/'
      : location.pathname.startsWith(path);

  return (
    <>
      <nav style={s.nav}>
        {/* Logo */}
        <Link to="/" style={s.logo}>📦 JSMSTOCK</Link>

        {/* Desktop links */}
        <div style={s.links}>
          {links.map(l => (
            <Link key={l.to} to={l.to}
              style={{ ...s.link, ...(isActive(l.to) ? s.activeLink : {}) }}>
              {l.label}
            </Link>
          ))}
        </div>

        {/* User area */}
        <div style={s.userArea}>
          <button style={s.userBtn} onClick={() => setDropOpen(!dropOpen)}>
            <div style={s.avatar}>
              {userInfo?.name?.charAt(0)?.toUpperCase() || '?'}
            </div>
            <div style={s.userText}>
              <span style={s.userName}>{userInfo?.name || 'User'}</span>
              <span style={s.shopName}>{userInfo?.shop_name || ''}</span>
            </div>
            <span style={s.chevron}>{dropOpen ? '▲' : '▼'}</span>
          </button>

          {/* Dropdown */}
          {dropOpen && (
            <div style={s.dropdown}>
              {/* Profile header */}
              <div style={s.dropHeader}>
                <div style={s.dropAvatar}>
                  {userInfo?.name?.charAt(0)?.toUpperCase() || '?'}
                </div>
                <div>
                  <div style={s.dropName}>{userInfo?.name}</div>
                  <div style={s.dropEmail}>{userInfo?.email}</div>
                  <div style={s.dropShop}>🏪 {userInfo?.shop_name}</div>
                </div>
              </div>

              {/* Trial info */}
              {/* ✅ Plan badge */}
              {userInfo?.is_paid ? (
                <div style={{
                  padding:'8px 16px',
                  background: userInfo?.account_type==='premium' ? '#FFF9E6' :
                               userInfo?.account_type==='business' ? '#F3E5F5' : '#E8F8F0',
                  color: userInfo?.account_type==='premium' ? '#C9A84C' :
                         userInfo?.account_type==='business' ? '#9B59B6' : '#27AE60',
                  fontSize:'13px', fontWeight:'700', textAlign:'center',
                }}>
                  {userInfo?.account_type==='premium' ? '👑 Premium Plan Active' :
                   userInfo?.account_type==='business' ? '🏢 Business Plan Active' :
                   '✅ Pro Plan Active'}
                </div>
              ) : (
                <div style={s.trialInfo}>
                  ⏳ {userInfo?.days_left} நாள் trial மீதம்
                </div>
              )}

              <div style={s.dropDivider} />

              {/* ✅ Change Password option */}
              <button
                style={s.dropMenuItem}
                onClick={() => { setDropOpen(false); setShowChangePwd(true); }}
              >
                🔑 Password மாற்று
              </button>

              <div style={s.dropDivider} />

              {/* Social links */}
              <div style={s.socialRow}>
                <a href="https://wa.me/919159933276" target="_blank" rel="noreferrer"
                   style={s.socialBtn} title="WhatsApp">📱</a>
                <a href="https://facebook.com/jsmstock" target="_blank" rel="noreferrer"
                   style={{ ...s.socialBtn, background: '#1877F2' }} title="Facebook">f</a>
                <a href="https://instagram.com/jsmstock" target="_blank" rel="noreferrer"
                   style={{ ...s.socialBtn, background: '#E4405F' }} title="Instagram">📸</a>
                <a href="https://youtube.com/@jsmstock" target="_blank" rel="noreferrer"
                   style={{ ...s.socialBtn, background: '#FF0000' }} title="YouTube">▶</a>
                <a href="https://linkedin.com/company/jsmstock" target="_blank" rel="noreferrer"
                   style={{ ...s.socialBtn, background: '#0A66C2' }} title="LinkedIn">in</a>
              </div>

              <div style={s.dropDivider} />

              {/* Logout */}
              <button style={s.dropLogout} onClick={handleLogout}>
                🚪 Logout
              </button>
            </div>
          )}
        </div>

        {/* Hamburger */}
        <button style={s.hamburger} onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? '✕' : '☰'}
        </button>
      </nav>

      {/* Mobile menu */}
      {menuOpen && (
        <div style={s.mobileMenu}>
          <div style={s.mobileUser}>
            <div style={s.mobileAvatar}>
              {userInfo?.name?.charAt(0)?.toUpperCase() || '?'}
            </div>
            <div>
              <div style={s.mobileUserName}>{userInfo?.name}</div>
              <div style={s.mobileShop}>🏪 {userInfo?.shop_name}</div>
            </div>
          </div>

          {links.map(l => (
            <Link key={l.to} to={l.to}
              style={{ ...s.mobileLink, ...(isActive(l.to) ? s.mobileLinkActive : {}) }}
              onClick={() => setMenuOpen(false)}>
              {l.label}
            </Link>
          ))}

          {/* ✅ Change Password in mobile menu */}
          <button
            style={s.mobileChangePwd}
            onClick={() => { setMenuOpen(false); setShowChangePwd(true); }}
          >
            🔑 Password மாற்று
          </button>

          {/* Social links */}
          <div style={s.mobileSocialRow}>
            <a href="https://wa.me/xxxx" target="_blank" rel="noreferrer"
               style={s.mobileSocialBtn}>📱 WhatsApp</a>
            <a href="https://facebook.com/jsmstock" target="_blank" rel="noreferrer"
               style={{ ...s.mobileSocialBtn, background: '#1877F2' }}>📘 Facebook</a>
            <a href="https://instagram.com/jsmstock" target="_blank" rel="noreferrer"
               style={{ ...s.mobileSocialBtn, background: '#E4405F' }}>📸 Instagram</a>
            <a href="https://youtube.com/@jsmstock" target="_blank" rel="noreferrer"
               style={{ ...s.mobileSocialBtn, background: '#FF0000' }}>🎥 YouTube</a>
            <a href="https://linkedin.com/company/jsmstock" target="_blank" rel="noreferrer"
               style={{ ...s.mobileSocialBtn, background: '#0A66C2' }}>💼 LinkedIn</a>
          </div>

          <button style={s.mobileLogout} onClick={handleLogout}>
            🚪 Logout — {userInfo?.name}
          </button>
        </div>
      )}

      {/* Backdrop */}
      {dropOpen && (
        <div style={s.backdrop} onClick={() => setDropOpen(false)} />
      )}

      {/* ✅ Change Password Modal */}
      {showChangePwd && (
        <ChangePassword onClose={() => setShowChangePwd(false)} />
      )}
    </>
  );
}

const s = {
  nav: {
    backgroundColor: '#2c3e50', padding: '0 20px',
    display: 'flex', justifyContent: 'space-between',
    alignItems: 'center', height: '58px', position: 'sticky',
    top: 0, zIndex: 200,
  },
  logo: {
    color: 'white', textDecoration: 'none', fontWeight: '900',
    fontSize: '18px', letterSpacing: '0.5px', flexShrink: 0,
  },
  links: { display: 'flex', gap: '4px', alignItems: 'center', flexWrap: 'nowrap', overflow: 'hidden' },
  link: {
    color: 'rgba(255,255,255,0.75)', textDecoration: 'none',
    fontSize: '13px', fontWeight: '500', padding: '6px 10px',
    borderRadius: '6px', transition: 'all 0.2s', whiteSpace: 'nowrap',
  },
  activeLink: { backgroundColor: 'rgba(255,255,255,0.15)', color: 'white' },

  userArea:  { position: 'relative', flexShrink: 0 },
  userBtn: {
    display: 'flex', alignItems: 'center', gap: '8px',
    background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: '8px', padding: '6px 12px', cursor: 'pointer',
    color: 'white', transition: 'all 0.2s',
  },
  avatar: {
    width: '30px', height: '30px', borderRadius: '50%', background: '#3498db',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '14px', fontWeight: '700', color: 'white', flexShrink: 0,
  },
  userText:  { display: 'flex', flexDirection: 'column', textAlign: 'left' },
  userName:  { fontSize: '13px', fontWeight: '600', color: 'white', lineHeight: 1.2 },
  shopName:  { fontSize: '11px', color: 'rgba(255,255,255,0.6)', lineHeight: 1.2 },
  chevron:   { fontSize: '10px', color: 'rgba(255,255,255,0.5)' },

  dropdown: {
    position: 'absolute', top: 'calc(100% + 8px)', right: 0,
    background: 'white', borderRadius: '12px',
    boxShadow: '0 10px 40px rgba(0,0,0,0.2)', minWidth: '240px',
    zIndex: 300, overflow: 'hidden', border: '1px solid #eee',
  },
  dropHeader: {
    display: 'flex', gap: '12px', alignItems: 'center',
    padding: '16px', background: '#f8f9fa',
  },
  dropAvatar: {
    width: '44px', height: '44px', borderRadius: '50%', background: '#2c3e50',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '20px', fontWeight: '700', color: 'white', flexShrink: 0,
  },
  dropName:  { fontWeight: '700', fontSize: '15px', color: '#2c3e50' },
  dropEmail: { fontSize: '12px', color: '#888', marginTop: '2px' },
  dropShop:  { fontSize: '12px', color: '#3498db', fontWeight: '600', marginTop: '2px' },
  trialInfo: {
    padding: '8px 16px', background: '#fff8e1',
    color: '#856404', fontSize: '13px', fontWeight: '600', textAlign: 'center',
  },
  dropDivider: { height: '1px', background: '#eee' },

  // ✅ Change Password menu item
  dropMenuItem: {
    width: '100%', padding: '12px 16px', background: 'none', border: 'none',
    cursor: 'pointer', textAlign: 'left', fontSize: '14px',
    fontWeight: '600', color: '#2c3e50',
    display: 'flex', alignItems: 'center', gap: '8px',
  },

  dropLogout: {
    width: '100%', padding: '13px 16px', background: 'none', border: 'none',
    cursor: 'pointer', textAlign: 'left', fontSize: '14px',
    fontWeight: '600', color: '#e74c3c', transition: 'background 0.2s',
  },
  socialRow: {
    display: 'flex', gap: '8px', padding: '10px 16px', justifyContent: 'center',
  },
  socialBtn: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    width: '34px', height: '34px', borderRadius: '8px', background: '#25D366',
    color: 'white', textDecoration: 'none', fontSize: '14px', fontWeight: '700',
  },

  hamburger: {
    display: 'none', background: 'none', border: 'none',
    color: 'white', fontSize: '22px', cursor: 'pointer',
  },
  mobileMenu: {
    display: 'flex', flexDirection: 'column', backgroundColor: '#2c3e50',
    padding: '10px 20px 20px', gap: '4px',
    borderBottom: '2px solid rgba(255,255,255,0.1)',
    position: 'sticky', top: '58px', zIndex: 199,
  },
  mobileUser: {
    display: 'flex', alignItems: 'center', gap: '12px',
    padding: '12px 10px', borderBottom: '1px solid rgba(255,255,255,0.15)',
    marginBottom: '8px',
  },
  mobileAvatar: {
    width: '38px', height: '38px', borderRadius: '50%', background: '#3498db',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '18px', fontWeight: '700', color: 'white', flexShrink: 0,
  },
  mobileUserName: { color: 'white', fontWeight: '700', fontSize: '15px' },
  mobileShop: { color: 'rgba(255,255,255,0.6)', fontSize: '12px', marginTop: '2px' },
  mobileLink: {
    color: 'rgba(255,255,255,0.8)', textDecoration: 'none', padding: '11px 10px',
    borderRadius: '6px', fontSize: '15px', fontWeight: '500',
    borderBottom: '1px solid rgba(255,255,255,0.06)',
  },
  mobileLinkActive: { backgroundColor: 'rgba(255,255,255,0.12)', color: 'white' },

  // ✅ Change Password mobile button
  mobileChangePwd: {
    background: 'rgba(255,255,255,0.1)', color: 'white', border: 'none',
    padding: '11px 10px', borderRadius: '6px', cursor: 'pointer',
    fontSize: '15px', fontWeight: '600', textAlign: 'left',
    borderBottom: '1px solid rgba(255,255,255,0.06)',
  },

  mobileSocialRow: { display: 'flex', flexDirection: 'column', gap: '6px', padding: '10px 0' },
  mobileSocialBtn: {
    display: 'block', padding: '10px 16px', background: '#25D366',
    color: 'white', textDecoration: 'none', borderRadius: '8px',
    fontSize: '13px', fontWeight: '600', textAlign: 'center',
  },
  mobileLogout: {
    background: '#e74c3c', color: 'white', border: 'none', padding: '12px',
    borderRadius: '8px', cursor: 'pointer', fontSize: '15px',
    fontWeight: '700', marginTop: '10px', textAlign: 'left',
  },
  backdrop: { position: 'fixed', inset: 0, zIndex: 199 },
};

export default Navbar;


